import * as Sentry from "@sentry/browser";

/**
 * Keep Sentry user context aligned with the ADS authenticated user profile.
 * Clears Sentry user when the profile is missing or has no stable identifier.
 */
export const syncSentryUserFromAdsUser = (user) => {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  const id =
    user.id != null
      ? String(user.id)
      : user.ObjectId != null
        ? String(user.ObjectId)
        : null;

  if (!id) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id,
    ...(user.email ? { email: user.email } : {}),
    ...(user.name ? { username: user.name } : {}),
  });
};
